import './src/styles/global.css'
import i18n, { i18nReady, SUPPORTED_LANGUAGES } from "./src/i18n"
import { trackPageView } from "./src/utils/tracking"
import { beginPageTracking, endPageTracking } from "./src/utils/pageEngagement"

// Gatsby waits for this promise before hydrating, so the first client render
// has the same translations the server used.
export const onClientEntry = () => {
  // Tab close / app switch doesn't go through onRouteUpdate, so the last
  // page visited needs its own flush. pagehide survives back-forward cache
  // better than beforeunload; visibilitychange is the fallback iOS Safari
  // needs since it doesn't fire pagehide reliably on every exit path.
  window.addEventListener('pagehide', endPageTracking)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') endPageTracking()
  })
  return i18nReady
}

// Gatsby's SPA navigation never reloads the page, so nothing tells GA4/GTM a
// new page was seen after the first load — this fires on every route change,
// including the initial one (prevLocation is null then), and fully replaces
// the GTM GA4-Configuration tag's own pageview (see docs/GTM_SETUP.md: that
// tag's trigger must be "Initialization", not "All Pages").
let lastTrackedPath = null
export const onRouteUpdate = ({ location, prevLocation }) => {
  const path = location.pathname + location.search
  if (path === lastTrackedPath) return
  if (prevLocation || lastTrackedPath) endPageTracking()
  lastTrackedPath = path
  trackPageView(path)
  beginPageTracking()
}

// No root GoogleReCaptchaProvider (see gatsby-ssr.js): forms use the
// shared RecaptchaProvider so pages without forms skip Google's script.

// Mirrors gatsby-ssr.js's wrapPageElement so the very first client render
// (hydration) resolves the same language the server just used, from the
// same source (pageContext.language) instead of re-deriving it from the
// URL. Also keeps i18n in sync on client-side (Gatsby Link) navigations.
export const wrapPageElement = ({ element, props }) => {
    const language = props?.pageContext?.language
    if (language && SUPPORTED_LANGUAGES.includes(language) && i18n.language !== language) {
        i18n.changeLanguage(language)
    }
    return element
}

const transitionDelay = 1
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  window.history.scrollRestoration = "manual";
  const currentPosition = getSavedScrollPosition(location);
  if(location.action === 'PUSH'){
    window.setTimeout(() => {
      window.scrollTo(...currentPosition)
    }, transitionDelay)
    return false
  }
}
